export const DEFAULT_SCOPE_NAME = "homeysv5"
